/**
 * The feed's route id, in one place because two files spell it.
 *
 * THE FEED IS A PATHLESS LAYOUT (see `router.tsx`): an index route cannot have
 * child paths, so the comments drawer that keeps the list mounted underneath it
 * has to hang off a layout with no path at all. That leaves the feed with no
 * path for the tab bar to compare `location.pathname` against — it has an id,
 * and the router reports the match as `/` + that id.
 *
 * SO THE TAB BAR ASKS FOR THE ID RATHER THAN A PATH, and it asks here rather
 * than repeating the string. Renaming the route in `router.tsx` while the tab
 * bar still looked for the old name would leave the Feed tab drawn inactive
 * under its own drawer, which no build and no screenshot reports.
 */
export const FEED_ROUTE_ID = 'feed';

/** The `routeId` a match wears for the feed layout, which is what `matches` reports. */
export const FEED_MATCH_ID = `/${FEED_ROUTE_ID}`;
